import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Requests from "./pages/Requests";
import Approvals from "./pages/Approvals";
import PurchaseOrders from "./pages/PurchaseOrders";
import POHistory from "./pages/POHistory";
import Vendors from "./pages/Vendors";
import Inventory from "./pages/Inventory";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/requests" element={<Shell><Requests /></Shell>} />
            <Route path="/approvals" element={<Shell><Approvals /></Shell>} />
            <Route path="/purchase-orders" element={<Shell><PurchaseOrders /></Shell>} />
            <Route path="/po-history" element={<Shell><POHistory /></Shell>} />
            <Route path="/vendors" element={<Shell><Vendors /></Shell>} />
            <Route path="/inventory" element={<Shell><Inventory /></Shell>} />
            <Route path="/analytics" element={<Shell><Analytics /></Shell>} />
            <Route path="/settings" element={<Shell><Settings /></Shell>} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          richColors
          closeButton
          toastOptions={{
            duration: 4000,
            className: "k-glass-strong",
          }}
        />
      </AuthProvider>
    </ThemeProvider>
  );
}
